import { Inject, Injectable } from '@angular/core'
import { contract } from '@ftr/annotations-contracts'
import { API_CONFIGURATION, AUTH_TOKEN_FETCHER, AuthTokenFetcher, FullApiClientConfiguration } from '@ftr/api-shared'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClient } from './types'

/**
 * Create a client service for ftr-annotations for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactory extends AnnotationsApiClientFactoryBase {
  constructor(
    @Inject(API_CONFIGURATION) private readonly config: FullApiClientConfiguration,
    @Inject(AUTH_TOKEN_FETCHER) authTokenFetcher: AuthTokenFetcher,
  ) {
    super(authTokenFetcher)
  }

  build(region: Region): AnnotationsApiClient {
    const baseUrl = this.config.annotationsApi.endpointMap[region]
    return this.buildClient(baseUrl, contract)
  }
}
